











 











const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UpdateReflectionGroupTitleMutation_meeting",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RetroReflectionGroup",
      "kind": "LinkedField",
      "name": "reflectionGroup",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "titleIsUserDefined",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UpdateReflectionGroupTitlePayload",
  "abstractKey": null
};

(node ).hash = "67646ee2f0b7e8d50a70a5a998a9cbcc";

export default node;
